import WechatLoginCode from "./wechatLoginCode.vue";
export default WechatLoginCode;

